import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { RootContext } from "@-/dev.improve.haniverse.routes._context";

/**
 * Whether the current device should render the sidebar layout instead of bottom tabs.
 *
 * Native-only concept: landscape orientation swaps the bottom tabs for the sidebar drawer,
 * matching the existing tablet/landscape behavior. Web never uses this sidebar: its navigation is
 * the site header (`WebPrimaryControlsStrip`) plus per-page section sidebars, and the web branches
 * in `NavLayoutContent` / `AppLayoutContent` return before consulting this.
 */
export function useUsesSidebarLayout(): boolean {
  const [windowDimensions] = useContextSelectors(RootContext, (c) => c.windowDimensions);
  const { height: windowHeight, width: windowWidth } = windowDimensions;

  return windowWidth > windowHeight;
}
